"use strict";
exports.__esModule = true;
var react_1 = require("react");
exports["default"] = typeof window !== 'undefined' ? react_1.useLayoutEffect : react_1.useEffect;
